import React, { useEffect } from "react";
import { Container, Box, Typography, CircularProgress } from "@mui/material";
import { AUTH_URL } from "../../constants/urls";

/**
 * LoginPage - Redirects to Auth Portal
 *
 * Spotlight no longer handles login directly. Users are redirected to
 * the central Auth Portal for authentication.
 */
const LoginPage: React.FC = () => {
  useEffect(() => {
    // Redirect to Auth Portal with return URL
    const returnUrl = encodeURIComponent(window.location.origin);
    window.location.href = `${AUTH_URL}/login?redirect=${returnUrl}`;
  }, []);

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body1" color="text.secondary">
          Redirecting to login...
        </Typography>
      </Box>
    </Container>
  );
};

export default LoginPage;
